module.exports = __webpack_public_path__ + "img/ebe4b02.jpg";